import ReactDOM from 'react-dom/client';
import "./global.css";
import { Provider } from "react-redux";
import { store } from "./state/state.tsx";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { getFirebaseAuthToken } from "./app/Common/utilityFunctions.ts";
import axios from "axios";
import App from "./app/Subscriptions/layout/App.tsx";
import { ErrorFallbackPage } from './app/Subscriptions/Pages/FallbackPages/errorFallback.tsx'
import { ErrorBoundary } from 'react-error-boundary'
import { CacheProvider } from '@emotion/react';
import emotionCache from './emotion-cache';

// Initialize axios interceptors
axios.interceptors.request.use(
    async (config: any) => {
        const token = await getFirebaseAuthToken()
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Render the app
ReactDOM.createRoot(document.getElementById('root')!).render(
    <>
        <ErrorBoundary onError={(error, errorInfo) => {
            console.error('Error:', error);
            console.error('Error Info:', errorInfo);
        }} FallbackComponent={ErrorFallbackPage}>
            <Provider store={store}>
                <CacheProvider value={emotionCache}>
                <div className={""}><App /></div>
                <ToastContainer />
                </CacheProvider>
            </Provider>
        </ErrorBoundary>
    </>,
)
